import { Fragment } from 'react';
import { observer } from 'mobx-react-lite';

import { HeadLine, HeadLineMore } from '@/components/common/HeadLine';
import KeywordRanking from '@/components/common/KeywordRanking';

import useStore from '@/hooks/useStore';

const MonthlyKeyword = () => {
  const { MonthlyKeywordStore } = useStore();
  const { totalRankingData, categoryData } = MonthlyKeywordStore;

  if (!totalRankingData || !categoryData) return null;

  const { title, categoryName, item } = totalRankingData;

  return (
    <>
      <div className="keyword-ranking">
        <HeadLine title={title}>
          <HeadLineMore categoryName={categoryName} />
        </HeadLine>
        <KeywordRanking keywordRankingData={item} />
      </div>
      <div className="keyword-ranking">
        {categoryData.map((categoryItem, idx) => {
          if (!categoryItem?.item) return null;

          return (
            <Fragment key={`keywordRanking-${idx}`}>
              {idx === 0 && <HeadLine title={categoryItem.title} />}
              <div className="keyword-ranking__category">
                <HeadLine subTitle={categoryItem.categoryName}>
                  <HeadLineMore categoryName={categoryItem.categoryName} />
                </HeadLine>
              </div>
              <KeywordRanking keywordRankingData={categoryItem.item} isCategoryKeyword={true} />
            </Fragment>
          );
        })}
      </div>
    </>
  );
};

export default observer(MonthlyKeyword);
